"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpTxInfo = void 0;
var tslib_1 = require("tslib");
var axios_1 = (0, tslib_1.__importDefault)(require("axios"));
var http_request_setup_1 = require("./interceptors/http-request.setup");
var http_response_error_handler_1 = require("./interceptors/http-response-error.handler");
var http_response_success_handler_1 = require("./interceptors/http-response-success.handler");
var requester = axios_1.default.create({
    baseURL: process.env.REACT_APP_TX_BASE_URL,
});
requester.interceptors.request.use(http_request_setup_1.httpRequestSetup);
requester.interceptors.response.use(http_response_success_handler_1.httpResponseSuccessHandler, http_response_error_handler_1.httpResponseErrorHandler);
exports.httpTxInfo = {
    get: function (_a) {
        var url = _a.url, params = _a.params, headers = _a.headers;
        return requester({ method: 'get', url: url, params: params, headers: headers });
    },
    post: function (_a) {
        var url = _a.url, data = _a.data, headers = _a.headers;
        return requester({ method: 'post', url: url, data: data, headers: headers });
    },
    put: function (_a) {
        var url = _a.url, data = _a.data, headers = _a.headers;
        return requester({ method: 'put', url: url, data: data, headers: headers });
    },
    delete: function (_a) {
        var url = _a.url, headers = _a.headers;
        return requester({ method: 'delete', url: url, headers: headers });
    },
    patch: function (_a) {
        var url = _a.url, data = _a.data, headers = _a.headers;
        return requester({ method: 'patch', url: url, data: data, headers: headers });
    },
};
